/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Replace_EllipsesInputs */

const en_replace_ellipses = /** @type {(inputs: Replace_EllipsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace ..+ with Ellipses`)
};

const fr_replace_ellipses = /** @type {(inputs: Replace_EllipsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplacer ..+ par des points de suspension`)
};

const de_replace_ellipses = /** @type {(inputs: Replace_EllipsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ersetzen Sie ..+ durch Auslassungspunkte.`)
};

const it_replace_ellipses = /** @type {(inputs: Replace_EllipsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sostituisci ..+ con ellissi`)
};

const ru_replace_ellipses = /** @type {(inputs: Replace_EllipsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Замените ..+ многоточием.`)
};

const es_replace_ellipses = /** @type {(inputs: Replace_EllipsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reemplazar ..+ con puntos suspensivos`)
};

const zh_cn2_replace_ellipses = /** @type {(inputs: Replace_EllipsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将 ..+ 替换为省略号`)
};

const ja_replace_ellipses = /** @type {(inputs: Replace_EllipsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`..+ を省略記号に置き換える`)
};

const hi_replace_ellipses = /** @type {(inputs: Replace_EllipsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`..+ को एलिप्सिस से बदलें`)
};

const pt_pt2_replace_ellipses = /** @type {(inputs: Replace_EllipsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substitua ..+ por reticências`)
};

/**
* | output |
* | --- |
* | "Replace ..+ with Ellipses" |
*
* @param {Replace_EllipsesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const replace_ellipses = /** @type {((inputs?: Replace_EllipsesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Replace_EllipsesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_replace_ellipses(inputs)
	if (locale === "de") return de_replace_ellipses(inputs)
	if (locale === "it") return it_replace_ellipses(inputs)
	if (locale === "ru") return ru_replace_ellipses(inputs)
	if (locale === "es") return es_replace_ellipses(inputs)
	if (locale === "zh-CN") return zh_cn2_replace_ellipses(inputs)
	if (locale === "ja") return ja_replace_ellipses(inputs)
	if (locale === "hi") return hi_replace_ellipses(inputs)
	if (locale === "pt-PT") return pt_pt2_replace_ellipses(inputs)
	return en_replace_ellipses(inputs)
});